// reservebar-address-modal.js
import {
	getLiquidAddressString,
	getLiquidClient,
	getReservebarLabel,
	getReservebarUnavailableMessage,
	normalizeLiquidProduct,
	syncLiquidSdkAddress
} from './reservebar-config';
import {
	generateCartSettings,
	generateCartTemplateBody,
	getAddresParams
} from './reservebar-cart-modal';

import {generateProductSummer} from './reservebar-product-summer';
import {setStore} from 'Assets/js/modules/library-modules/reservebar/reservebar-store';

export let reservebarLastProductMeta = {};

export function setReservebarLastProductMeta(meta) {
	reservebarLastProductMeta = meta || {};
}

// Generate and open an ADDRESS modal (step 1)
export function generateAddressModal(liquidGroupingID, meta = {}) {
	if (document.querySelectorAll('.reservebar-address').length > 0) {
		return false;
	}
	reservebarLastProductMeta = meta || reservebarLastProductMeta;
	const modal = document.createElement('div');
	modal.className = 'reservebar-address';
	modal.innerHTML = `
    <div class="reservebar-address__overlay"></div>
    <div class="reservebar-address__content" liquid-id="${liquidGroupingID}">
      <div class="reservebar-address__close"></div>
      <h4 class="reservebar-address__title">${getReservebarLabel(
			'reservebar_address_title',
			'Check Price and Availability'
		)}</h4>

      <div class="reservebar-address__status" role="status"></div>

      <label class="reservebar-address__label">${getReservebarLabel(
			'reservebar_address_label',
			'Enter your shipping address'
		)}</label>
      <div class="reservebar-address__search">
        <input
          type="text"
          class="reservebar-address__input"
          placeholder="${getReservebarLabel(
				'reservebar_address_placeholder',
				'Start typing your address'
			)}"
          autocomplete="off"
        />
        <ul class="reservebar-address__suggestions"></ul>
      </div>
      <div class="reservebar-address__error" aria-live="polite"></div>
      <div class="reservebar-address__cart" hidden></div>

      <div class="rb-address-ctas">
        <button class="liquid-continue-to-cart" >${getReservebarLabel(
			'reservebar_address_enter_label',
			'Enter'
		)}</button>
        <a class="liquid-find-us" href="${getReservebarLabel(
			'reservebar_find_to_us_link',
			'/where-to-buy/'
		)}" style="display:none">${getReservebarLabel(
		'reservebar_find_to_us_label',
		'Find us'
	)}</a>
      </div>

      <div class='liquid-cmsg'>
        <p class="p-xxs-sizing">${getReservebarLabel(
			'reservebar_address_legal_notice',
			'Due to legal restrictions, our spirits are currently only available to ship to AZ, CA, CO, CT, DC, DE, FL, IA, IL, IN, KY, LA, MD, ME, MN, MO, MT, NC, NE, NH, NJ, NM, NV, NY, OK, PA, RI, SC, VA, WA, WI, WV and WY – we are always adding new locations, stay tuned!'
		)}</p>
      </div>
      <div class='reservebar-address__footer'>
        <p class="p-xxs-sizing">${getReservebarLabel(
			'reservebar_address_footer_notice',
			'All orders are fulfilled by ReserveBar, an independent third party that facilitates orders with licensed retailers in your state.'
		)}</p>
      </div>
    </div>
  `;

	document.body.appendChild(modal);
	document.body.classList.add('lock-position');

	const handleLiquidCartClose = (e) => {
		if (!e.target.closest('.liquid-cart-close')) return;
		if (modal.isConnected) {
			closeModal();
		}
	};

	// Close handlers
	const closeModal = () => {
		document.removeEventListener('click', handleLiquidCartClose, true);
		modal.remove();
		document.body.classList.remove('lock-position');
		if (document.body.classList.contains('single-product')){
			const gid = contentEl.getAttribute('liquid-id');

			const productSummer = document.querySelector('.rb-product-summer');
			productSummer.querySelector('.reservebar-product-summer').remove();
			generateProductSummer(
				gid,
				productSummer,
				reservebarLastProductMeta
			);
		}
	};
	modal
		.querySelector('.reservebar-address__close')
		.addEventListener('click', closeModal);
	modal
		.querySelector('.reservebar-address__overlay')
		.addEventListener('click', closeModal);

	document.addEventListener('click', handleLiquidCartClose, true);

	const contentEl = modal.querySelector('.reservebar-address__content');
	const continueBtn = modal.querySelector('.liquid-continue-to-cart');
	const findUsBtn = modal.querySelector('.liquid-find-us');
	const addressCtasEl = modal.querySelector('.rb-address-ctas');
	const cartContainerEl = modal.querySelector('.reservebar-address__cart');

	// Detect address typed/selected in Liquid typeahead

	const statusEl = modal.querySelector('.reservebar-address__status');

	const searchInput = contentEl.querySelector('.reservebar-address__input');
	const suggestionsEl = contentEl.querySelector(
		'.reservebar-address__suggestions'
	);
	const errorEl = contentEl.querySelector('.reservebar-address__error');

	// Local constants for dynamic button labels
	const LABEL_ENTER = getReservebarLabel(
		'reservebar_address_enter_label',
		'Enter'
	);

	let selectedPlace = null; // full place details
	let currentPredictions = []; // last predictions list
	let isLoadingPredictions = false;
	let searchDebounceTimer = null;

	function setLoadingPredictions(isLoading) {
		isLoadingPredictions = !!isLoading;

		// Toggle a CSS hook on the whole modal for a spinner, dimming, etc.
		if (modal) {
			modal.classList.toggle(
				'reservebar-address--loading',
				isLoadingPredictions
			);
		}

		// Disable/enable the main button and update its label
		if (continueBtn && addressCtasEl && !addressCtasEl.hidden) {
			continueBtn.textContent = isLoadingPredictions
				? getReservebarLabel(
						'reservebar_address_searching_label',
						'Searching...'
				  )
				: LABEL_ENTER;
		}
	}

	function hideInlineCart() {
		if (!cartContainerEl) return;
		cartContainerEl.innerHTML = '';
		cartContainerEl.hidden = true;
		if (addressCtasEl) {
			addressCtasEl.hidden = false;
		}
	}

	function showInlineCart() {
		if (!cartContainerEl) return;

		const gid = contentEl.getAttribute('liquid-id');
		cartContainerEl.innerHTML = generateCartTemplateBody({
			includeShipping: false
		});
		cartContainerEl.hidden = false;
		if (addressCtasEl) {
			addressCtasEl.hidden = true;
		}

		generateCartSettings(gid, cartContainerEl, {
			...reservebarLastProductMeta,
			onAddToCartSuccess: closeModal,
			openLiquidCart: true
		});
	}
	// Prefill input if _liquid_address cookie exists
	const existingAddr = getLiquidAddressString();
	if (existingAddr && searchInput) {
		searchInput.value = existingAddr;

		if (!meta.skipPrefillAvailabilityCheck) {
			const gidPrefill = contentEl.getAttribute('liquid-id');
			checkAddressRetailersWithProduct(gidPrefill, existingAddr);
		}
	}
	function setStatus(type, text) {
		// type: 'ok' | 'error' | ''
		statusEl.className =
			'reservebar-address__status' + (type ? ` is-${type}` : '');
		statusEl.textContent = text || '';
		if (type == 'error') {
			if (findUsBtn) findUsBtn.style.display = '';
		} else {
			if (findUsBtn) findUsBtn.style.display = 'none';
		}
	}

	// Liquid address predictions and selection
	async function fetchPredictions(query) {
		if (!query || query.length < 3) {
			if (suggestionsEl) {
				suggestionsEl.innerHTML = '';
			}
			selectedPlace = null;
			updateAddressState(false);
			return;
		}

		setLoadingPredictions(true);

		try {
			const liquid = await getLiquidClient();
			const predictions = await liquid.address({search: query});

			let list = [];
			if (Array.isArray(predictions)) {
				list = predictions;
			} else if (predictions && Array.isArray(predictions.predictions)) {
				list = predictions.predictions;
			}

			currentPredictions = list;
			if (suggestionsEl && currentPredictions.length) {
				renderSuggestions(currentPredictions);
				setStatus('', '');
			} else {
				setStatus(
					'error',
					getReservebarLabel(
						'reservebar_address_error_search',
						'Unable to search addresses right now.'
					)
				);
				if (findUsBtn) findUsBtn.style.display = '';
			}
		} catch (e) {
			console.error('[ReserveBar] address predictions error', e);
			if (errorEl) {
				setStatus(
					'error',
					getReservebarLabel(
						'reservebar_address_error_search',
						'Unable to search addresses right now.'
					)
				);

				if (findUsBtn) findUsBtn.style.display = '';
			}
		} finally {
			setLoadingPredictions(false);
		}
	}

	function renderSuggestions(predictions) {
		if (!suggestionsEl) return;
		suggestionsEl.innerHTML = '';
		predictions.forEach((p, index) => {
			const li = document.createElement('li');
			li.className = 'reservebar-address__suggestion';
			li.dataset.index = String(index);
			li.textContent = p.description;
			suggestionsEl.appendChild(li);
		});
	}

	async function fetchPlaceDetails(placeId) {
		try {
			const liquid = await getLiquidClient();
			// Liquid address details expect placeId key
			const placeDetails = await liquid.address({placeId: placeId});
			return placeDetails;
		} catch (e) {
			if (errorEl) {
				errorEl.textContent = getReservebarLabel(
					'reservebar_address_error_details',
					'Unable to load address details.'
				);
			}
			return null;
		}
	}

	// Check via Liquid product API whether this address has any retailers for the given product
	async function checkAddressRetailersWithProduct(
		liquidGroupingID,
		addressInput
	) {
		if (!liquidGroupingID) {
			updateAddressState(false);
			return;
		}

		// Show loading state while checking availability
		setLoadingPredictions(true);

		let hasRetailers = false;
		try {
			const liquid = await getLiquidClient();

			const params = getAddresParams(liquidGroupingID);

			const products = await liquid.product(params);
			const product = normalizeLiquidProduct(
				products,
				liquidGroupingID
			);

			if (product && Array.isArray(product.variants)) {
				// Consider "has retailers" if ANY variant has ANY retailer
				hasRetailers = product.variants.some(
					(v) =>
						Array.isArray(v.retailers) && v.retailers.length > 0
				);
			}

			// Attach a simple flag to the selectedPlace so updateAddressState can reuse it
			if (addressInput && typeof addressInput === 'object') {
				selectedPlace = addressInput;
			} else if (!selectedPlace) {
				selectedPlace = {description: addressInput};
			}

			if (!selectedPlace.reservebar) {
				selectedPlace.reservebar = {};
			}
			selectedPlace.reservebar.hasRetailers = hasRetailers;

			updateAddressState(true);
			setStore();
		} catch (e) {
			console.error(
				'[ReserveBar] checkAddressRetailersWithProduct error',
				e
			);
			setStatus(
				'error',
				getReservebarLabel(
					'reservebar_address_error_availability',
					'Unable to check product availability for this address right now.'
				)
			);

			updateAddressState(false);
		} finally {

			setLoadingPredictions(false);
		}
	}

	function updateAddressState(hasAddress) {
		if (!hasAddress || !selectedPlace) {
			hideInlineCart();
			if (continueBtn) {
				continueBtn.textContent = LABEL_ENTER;
			}
			return;
		}

		let hasRetailers = false;
		try {
			if (
				selectedPlace.reservebar &&
				typeof selectedPlace.reservebar.hasRetailers === 'boolean'
			) {
				hasRetailers = selectedPlace.reservebar.hasRetailers;
			}
		} catch (e) {
			console.warn('[ReserveBar] failed retailers check', e);
		}

		if (hasRetailers) {
			setStatus('', '');
			if (findUsBtn) findUsBtn.style.display = 'none';
			showInlineCart();
		} else {
			hideInlineCart();
			if (continueBtn) {
				continueBtn.textContent = LABEL_ENTER;
			}
			const gid = contentEl.getAttribute('liquid-id') || '';
			setStatus('error', getReservebarUnavailableMessage(gid));
			if (findUsBtn) findUsBtn.style.display = '';
		}
	}

	function setLiquidAddressCookieFromPlace(place) {
		syncLiquidSdkAddress(place, {resetCart: false});
	}

	// Wire input events
	if (searchInput) {
		const onInput = () => {
			const q = searchInput.value.trim();
			if (searchDebounceTimer) {
				clearTimeout(searchDebounceTimer);
			}

			selectedPlace = null;
			setStatus('', '');
			if (suggestionsEl) {
				suggestionsEl.innerHTML = '';
			}
			// While the user is typing, we assume that there is no valid address yet.
			updateAddressState(false);

			if (q.length < 3) {
				return;
			}

			searchDebounceTimer = window.setTimeout(() => {
				fetchPredictions(q);
			}, 300);
		};

		searchInput.addEventListener('input', onInput);

		searchInput.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				if (searchDebounceTimer) {
					clearTimeout(searchDebounceTimer);
				}
				const q = searchInput.value.trim();
				selectedPlace = null;
				hideInlineCart();
				setStatus('', '');
				fetchPredictions(q);
			}
		});
	}
	// Click on suggestion → select address + load details
	if (suggestionsEl) {
		suggestionsEl.addEventListener('click', async (e) => {
			const li = e.target.closest('.reservebar-address__suggestion');
			if (!li) return;

			if (
				!Array.isArray(currentPredictions) ||
				currentPredictions.length === 0
			) {
				return;
			}

			const index = Number(li.dataset.index || -1);
			if (
				Number.isNaN(index) ||
				index < 0 ||
				index >= currentPredictions.length
			) {
				return;
			}

			const prediction = currentPredictions[index];
			if (!prediction) return;

			// Fill input with chosen description
			if (searchInput) {
				searchInput.value = prediction.description;
			}
			suggestionsEl.innerHTML = '';

			const placeId = prediction.place_id || prediction.placeId;
			if (!placeId) {
				updateAddressState(false);
				return;
			}

			const place = await fetchPlaceDetails(placeId);
			if (!place) {
				updateAddressState(false);
				return;
			}

			selectedPlace = place;
			// Persist a simple address string into _liquid_address for reuse in cart modal

			setLiquidAddressCookieFromPlace(place);

			const gidClick = contentEl.getAttribute('liquid-id');

			await checkAddressRetailersWithProduct(gidClick, place);



		});
	}

	continueBtn.addEventListener('click', (e) => {
		e.preventDefault();

		if (!searchInput) {
			return;
		}
		const q = searchInput.value.trim();
		selectedPlace = null;
		hideInlineCart();
		setStatus('', '');
		fetchPredictions(q);
	});

	return true;
}
